// Translations for the website. To add a new language, add a new key with the language code.
export const LANGUAGES = [
  { code: "de", label: "Deutsch", flag: "DE" },
  { code: "en", label: "English", flag: "EN" },
  { code: "fr", label: "Français", flag: "FR" },
  { code: "es", label: "Español", flag: "ES" },
  { code: "it", label: "Italiano", flag: "IT" },
  { code: "pt", label: "Português", flag: "PT" },
  { code: "nl", label: "Nederlands", flag: "NL" },
  { code: "pl", label: "Polski", flag: "PL" },
  { code: "sv", label: "Svenska", flag: "SE" },
  { code: "da", label: "Dansk", flag: "DK" },
];

export const translations = {
  de: {
    heroTitle: "RAUS AUS DEM falschen LEBEN",
    heroSubtitle: "Wo Menschen sich verbinden, entsteht Zukunft.",
    heroInvite: "Eine Einladung, neu zu denken.",
    cta: "Komm mit",
    tapesTitle: "Lege eine Seite ein",
    tapesSubtitle: "Wähle Seite A oder Seite B und höre rein.",
    tapesIntro:
      "Manchmal braucht es Worte. Manchmal braucht es Stille. Und manchmal braucht es Musik, weil sie Dinge sagt, für die Sprache zu klein ist.",
    sideA: "RAUS AUS DEM falschen LEBEN",
    sideB: "OUT OF THE wrong LIFE",
    play: "Abspielen",
    pause: "Pause",
    audioMissing: "Audio noch nicht hinterlegt",
    back: "Zurück",
    backToHome: "Zurück zur Startseite",
    scrollToTop: "Nach oben",
    downloadHint: "Doppelklick auf",
    downloadHintSuffix: "zum Download",
    impressum: "Impressum",
    datenschutz: "Datenschutz",
    kontakt: "Kontakt",
    impressumTitle: "Impressum",
    datenschutzTitle: "Datenschutz",
    kontaktTitle: "Kontakt",
    placeholder: "Inhalt folgt in Kürze.",
    rights: "Alle Rechte vorbehalten.",
    languageLabel: "Sprache",
    menuEditorial: "Editorial",
    menuRaus: "RAUS AUS DEM falschen LEBEN",
    menuSong: "Der Song",
    menuSocialSeller: "Be a Social Seller",
    menuInspiration: "Inspiration",
    menuStimmen: "Stimmen",
    menuKontakt: "Kontakt",
    menuDownloads: "Downloads",
    presseTitle: "Presse",
    logoTitle: "RAUS AUS DEM falschen LEBEN",
    logoSubtitle: "Eine Socializerwelle",
    downloadsTitle: "Downloads",
    downloadsIntro:
      "Hier kannst du den Song und alle weiteren Materialien herunterladen. Für dich. Für deinen Weg.",
    songListenNow: "Jetzt anhören",
    songDownload: "Song herunterladen",
  },
  en: {
    heroTitle: "RAUS AUS DEM falschen LEBEN",
    heroSubtitle: "Where people connect, the future begins.",
    heroInvite: "An invitation to think anew.",
    cta: "Come along",
    tapesTitle: "Insert a side",
    tapesSubtitle: "Pick Side A or Side B and listen.",
    tapesIntro:
      "Sometimes we need words. Sometimes we need silence. And sometimes we need music, because it says things for which language is too small.",
    sideA: "RAUS AUS DEM falschen LEBEN",
    sideB: "OUT OF THE wrong LIFE",
    play: "Play",
    pause: "Pause",
    audioMissing: "Audio not yet uploaded",
    back: "Back",
    backToHome: "Back to home",
    scrollToTop: "Back to top",
    downloadHint: "Double-click",
    downloadHintSuffix: "to download",
    impressum: "Imprint",
    datenschutz: "Privacy",
    kontakt: "Contact",
    impressumTitle: "Imprint",
    datenschutzTitle: "Privacy Policy",
    kontaktTitle: "Contact",
    placeholder: "Content coming soon.",
    rights: "All rights reserved.",
    languageLabel: "Language",
    menuEditorial: "Editorial",
    menuRaus: "RAUS AUS DEM falschen LEBEN",
    menuSong: "The Song",
    menuSocialSeller: "Be a Social Seller",
    menuInspiration: "Inspiration",
    menuStimmen: "Voices",
    menuKontakt: "Contact",
    menuDownloads: "Downloads",
    presseTitle: "Press",
    logoTitle: "RAUS AUS DEM falschen LEBEN",
    logoSubtitle: "A Socializer Wave",
    downloadsTitle: "Downloads",
    downloadsIntro:
      "Here you can download the song and all further materials. For you. For your way.",
    songListenNow: "Listen now",
    songDownload: "Download song",
  },
  fr: {
    heroTitle: "RAUS AUS DEM falschen LEBEN",
    heroSubtitle: "Là où les gens se rencontrent, l'avenir commence.",
    heroInvite: "Une invitation à repenser.",
    cta: "Viens avec moi",
    tapesTitle: "Insère une face",
    tapesSubtitle: "Choisis la face A ou B et écoute.",
    tapesIntro:
      "Parfois il faut des mots. Parfois il faut du silence. Et parfois il faut de la musique, parce qu'elle dit ce que la langue est trop petite pour dire.",
    sideA: "RAUS AUS DEM falschen LEBEN",
    sideB: "OUT OF THE wrong LIFE",
    play: "Lecture",
    pause: "Pause",
    audioMissing: "Audio non encore téléversé",
    back: "Retour",
    backToHome: "Retour à l'accueil",
    scrollToTop: "Haut de page",
    downloadHint: "Double-cliquez sur",
    downloadHintSuffix: "pour télécharger",
    impressum: "Mentions légales",
    datenschutz: "Confidentialité",
    kontakt: "Contact",
    impressumTitle: "Mentions légales",
    datenschutzTitle: "Politique de confidentialité",
    kontaktTitle: "Contact",
    placeholder: "Contenu à venir.",
    rights: "Tous droits réservés.",
    languageLabel: "Langue",
    menuEditorial: "Éditorial",
    menuRaus: "RAUS AUS DEM falschen LEBEN",
    menuSong: "La chanson",
    menuSocialSeller: "Be a Social Seller",
    menuInspiration: "Inspiration",
    menuStimmen: "Voix",
    menuKontakt: "Contact",
    menuDownloads: "Téléchargements",
    presseTitle: "Presse",
    logoTitle: "RAUS AUS DEM falschen LEBEN",
    logoSubtitle: "Une vague Socializer",
    downloadsTitle: "Téléchargements",
    downloadsIntro:
      "Ici tu peux télécharger la chanson et tous les autres documents. Pour toi. Pour ton chemin.",
    songListenNow: "Écouter maintenant",
    songDownload: "Télécharger la chanson",
  },
  es: {
    heroTitle: "RAUS AUS DEM falschen LEBEN",
    heroSubtitle: "Donde las personas se conectan, nace el futuro.",
    heroInvite: "Una invitación a pensar de nuevo.",
    cta: "Ven conmigo",
    tapesTitle: "Inserta un lado",
    tapesSubtitle: "Elige el Lado A o B y escucha.",
    tapesIntro:
      "A veces hacen falta palabras. A veces hace falta silencio. Y a veces hace falta música, porque dice cosas para las que el lenguaje se queda corto.",
    sideA: "RAUS AUS DEM falschen LEBEN",
    sideB: "OUT OF THE wrong LIFE",
    play: "Reproducir",
    pause: "Pausa",
    audioMissing: "Audio aún no cargado",
    back: "Volver",
    backToHome: "Volver al inicio",
    scrollToTop: "Arriba",
    downloadHint: "Doble clic en",
    downloadHintSuffix: "para descargar",
    impressum: "Aviso legal",
    datenschutz: "Privacidad",
    kontakt: "Contacto",
    impressumTitle: "Aviso legal",
    datenschutzTitle: "Política de privacidad",
    kontaktTitle: "Contacto",
    placeholder: "Contenido próximamente.",
    rights: "Todos los derechos reservados.",
    languageLabel: "Idioma",
    menuEditorial: "Editorial",
    menuRaus: "RAUS AUS DEM falschen LEBEN",
    menuSong: "La canción",
    menuSocialSeller: "Be a Social Seller",
    menuInspiration: "Inspiración",
    menuStimmen: "Voces",
    menuKontakt: "Contacto",
    menuDownloads: "Descargas",
    presseTitle: "Prensa",
    logoTitle: "RAUS AUS DEM falschen LEBEN",
    logoSubtitle: "Una ola Socializer",
    downloadsTitle: "Descargas",
    downloadsIntro:
      "Aquí puedes descargar la canción y todos los demás materiales. Para ti. Para tu camino.",
    songListenNow: "Escuchar ahora",
    songDownload: "Descargar canción",
  },
  it: {
    heroTitle: "RAUS AUS DEM falschen LEBEN",
    heroSubtitle: "Dove le persone si incontrano, nasce il futuro.",
    heroInvite: "Un invito a ripensare.",
    cta: "Vieni con me",
    tapesTitle: "Inserisci un lato",
    tapesSubtitle: "Scegli il Lato A o B e ascolta.",
    tapesIntro:
      "A volte servono le parole. A volte serve il silenzio. E a volte serve la musica, perché dice ciò per cui la lingua è troppo piccola.",
    sideA: "RAUS AUS DEM falschen LEBEN",
    sideB: "OUT OF THE wrong LIFE",
    play: "Riproduci",
    pause: "Pausa",
    audioMissing: "Audio non ancora caricato",
    back: "Indietro",
    backToHome: "Torna alla home",
    scrollToTop: "Su",
    downloadHint: "Doppio clic su",
    downloadHintSuffix: "per scaricare",
    impressum: "Note legali",
    datenschutz: "Privacy",
    kontakt: "Contatti",
    impressumTitle: "Note legali",
    datenschutzTitle: "Informativa sulla privacy",
    kontaktTitle: "Contatti",
    placeholder: "Contenuto in arrivo.",
    rights: "Tutti i diritti riservati.",
    languageLabel: "Lingua",
    menuEditorial: "Editoriale",
    menuRaus: "RAUS AUS DEM falschen LEBEN",
    menuSong: "La canzone",
    menuSocialSeller: "Be a Social Seller",
    menuInspiration: "Ispirazione",
    menuStimmen: "Voci",
    menuKontakt: "Contatti",
    menuDownloads: "Download",
    presseTitle: "Stampa",
    logoTitle: "RAUS AUS DEM falschen LEBEN",
    logoSubtitle: "Un'onda Socializer",
    downloadsTitle: "Download",
    downloadsIntro:
      "Qui puoi scaricare la canzone e tutti gli altri materiali. Per te. Per il tuo cammino.",
    songListenNow: "Ascolta ora",
    songDownload: "Scarica canzone",
  },
  pt: {
    heroTitle: "RAUS AUS DEM falschen LEBEN",
    heroSubtitle: "Onde as pessoas se conectam, o futuro nasce.",
    heroInvite: "Um convite para pensar de novo.",
    cta: "Vem comigo",
    tapesTitle: "Insira um lado",
    tapesSubtitle: "Escolha o Lado A ou B e ouça.",
    tapesIntro:
      "Às vezes precisamos de palavras. Às vezes precisamos de silêncio. E às vezes precisamos de música, porque ela diz o que a linguagem é pequena demais para dizer.",
    sideA: "RAUS AUS DEM falschen LEBEN",
    sideB: "OUT OF THE wrong LIFE",
    play: "Reproduzir",
    pause: "Pausa",
    audioMissing: "Áudio ainda não enviado",
    back: "Voltar",
    backToHome: "Voltar ao início",
    scrollToTop: "Topo",
    downloadHint: "Clique duplo em",
    downloadHintSuffix: "para baixar",
    impressum: "Aviso legal",
    datenschutz: "Privacidade",
    kontakt: "Contato",
    impressumTitle: "Aviso legal",
    datenschutzTitle: "Política de privacidade",
    kontaktTitle: "Contato",
    placeholder: "Conteúdo em breve.",
    rights: "Todos os direitos reservados.",
    languageLabel: "Idioma",
    menuEditorial: "Editorial",
    menuRaus: "RAUS AUS DEM falschen LEBEN",
    menuSong: "A canção",
    menuSocialSeller: "Be a Social Seller",
    menuInspiration: "Inspiração",
    menuStimmen: "Vozes",
    menuKontakt: "Contato",
    menuDownloads: "Downloads",
    presseTitle: "Imprensa",
    logoTitle: "RAUS AUS DEM falschen LEBEN",
    logoSubtitle: "Uma onda Socializer",
    downloadsTitle: "Downloads",
    downloadsIntro:
      "Aqui você pode baixar a música e todos os outros materiais. Para você. Para o seu caminho.",
    songListenNow: "Ouvir agora",
    songDownload: "Baixar música",
  },
  nl: {
    heroTitle: "RAUS AUS DEM falschen LEBEN",
    heroSubtitle: "Waar mensen verbinden, ontstaat de toekomst.",
    heroInvite: "Een uitnodiging om opnieuw te denken.",
    cta: "Kom mee",
    tapesTitle: "Plaats een kant",
    tapesSubtitle: "Kies kant A of B en luister.",
    tapesIntro:
      "Soms zijn er woorden nodig. Soms is er stilte nodig. En soms is er muziek nodig, omdat zij dingen zegt waarvoor taal te klein is.",
    sideA: "RAUS AUS DEM falschen LEBEN",
    sideB: "OUT OF THE wrong LIFE",
    play: "Afspelen",
    pause: "Pauze",
    audioMissing: "Audio nog niet geüpload",
    back: "Terug",
    backToHome: "Terug naar start",
    scrollToTop: "Naar boven",
    downloadHint: "Dubbelklik op",
    downloadHintSuffix: "om te downloaden",
    impressum: "Colofon",
    datenschutz: "Privacy",
    kontakt: "Contact",
    impressumTitle: "Colofon",
    datenschutzTitle: "Privacybeleid",
    kontaktTitle: "Contact",
    placeholder: "Inhoud volgt binnenkort.",
    rights: "Alle rechten voorbehouden.",
    languageLabel: "Taal",
    menuEditorial: "Editorial",
    menuRaus: "RAUS AUS DEM falschen LEBEN",
    menuSong: "Het lied",
    menuSocialSeller: "Be a Social Seller",
    menuInspiration: "Inspiratie",
    menuStimmen: "Stemmen",
    menuKontakt: "Contact",
    menuDownloads: "Downloads",
    presseTitle: "Pers",
    logoTitle: "RAUS AUS DEM falschen LEBEN",
    logoSubtitle: "Een Socializer-golf",
    downloadsTitle: "Downloads",
    downloadsIntro:
      "Hier kun je het lied en alle andere materialen downloaden. Voor jou. Voor jouw weg.",
    songListenNow: "Nu luisteren",
    songDownload: "Lied downloaden",
  },
  pl: {
    heroTitle: "RAUS AUS DEM falschen LEBEN",
    heroSubtitle: "Tam, gdzie łączą się ludzie, rodzi się przyszłość.",
    heroInvite: "Zaproszenie do nowego myślenia.",
    cta: "Chodź ze mną",
    tapesTitle: "Włóż stronę",
    tapesSubtitle: "Wybierz stronę A lub B i posłuchaj.",
    tapesIntro:
      "Czasem potrzebne są słowa. Czasem potrzebna jest cisza. A czasem potrzebna jest muzyka, bo mówi to, na co język jest za mały.",
    sideA: "RAUS AUS DEM falschen LEBEN",
    sideB: "OUT OF THE wrong LIFE",
    play: "Odtwórz",
    pause: "Pauza",
    audioMissing: "Audio jeszcze nie przesłane",
    back: "Wstecz",
    backToHome: "Powrót do strony głównej",
    scrollToTop: "Do góry",
    downloadHint: "Kliknij dwukrotnie",
    downloadHintSuffix: "aby pobrać",
    impressum: "Impressum",
    datenschutz: "Prywatność",
    kontakt: "Kontakt",
    impressumTitle: "Impressum",
    datenschutzTitle: "Polityka prywatności",
    kontaktTitle: "Kontakt",
    placeholder: "Treść wkrótce.",
    rights: "Wszelkie prawa zastrzeżone.",
    languageLabel: "Język",
    menuEditorial: "Editorial",
    menuRaus: "RAUS AUS DEM falschen LEBEN",
    menuSong: "Piosenka",
    menuSocialSeller: "Be a Social Seller",
    menuInspiration: "Inspiracja",
    menuStimmen: "Głosy",
    menuKontakt: "Kontakt",
    menuDownloads: "Pliki do pobrania",
    presseTitle: "Prasa",
    logoTitle: "RAUS AUS DEM falschen LEBEN",
    logoSubtitle: "Fala Socializer",
    downloadsTitle: "Pliki do pobrania",
    downloadsIntro:
      "Tutaj możesz pobrać piosenkę i wszystkie inne materiały. Dla Ciebie. Na Twoją drogę.",
    songListenNow: "Posłuchaj teraz",
    songDownload: "Pobierz piosenkę",
  },
  sv: {
    heroTitle: "RAUS AUS DEM falschen LEBEN",
    heroSubtitle: "Där människor möts börjar framtiden.",
    heroInvite: "En inbjudan att tänka nytt.",
    cta: "Följ med",
    tapesTitle: "Sätt i en sida",
    tapesSubtitle: "Välj sida A eller B och lyssna.",
    tapesIntro:
      "Ibland behövs ord. Ibland behövs tystnad. Och ibland behövs musik, för den säger sådant som språket är för litet för.",
    sideA: "RAUS AUS DEM falschen LEBEN",
    sideB: "OUT OF THE wrong LIFE",
    play: "Spela",
    pause: "Paus",
    audioMissing: "Ljud ej uppladdat",
    back: "Tillbaka",
    backToHome: "Till startsidan",
    scrollToTop: "Till toppen",
    downloadHint: "Dubbelklicka på",
    downloadHintSuffix: "för att ladda ner",
    impressum: "Information",
    datenschutz: "Integritet",
    kontakt: "Kontakt",
    impressumTitle: "Information",
    datenschutzTitle: "Integritetspolicy",
    kontaktTitle: "Kontakt",
    placeholder: "Innehåll kommer snart.",
    rights: "Alla rättigheter förbehållna.",
    languageLabel: "Språk",
    menuEditorial: "Editorial",
    menuRaus: "RAUS AUS DEM falschen LEBEN",
    menuSong: "Låten",
    menuSocialSeller: "Be a Social Seller",
    menuInspiration: "Inspiration",
    menuStimmen: "Röster",
    menuKontakt: "Kontakt",
    menuDownloads: "Nedladdningar",
    presseTitle: "Press",
    logoTitle: "RAUS AUS DEM falschen LEBEN",
    logoSubtitle: "En Socializer-våg",
    downloadsTitle: "Nedladdningar",
    downloadsIntro:
      "Här kan du ladda ner låten och allt annat material. För dig. För din väg.",
    songListenNow: "Lyssna nu",
    songDownload: "Ladda ner låt",
  },
  da: {
    heroTitle: "RAUS AUS DEM falschen LEBEN",
    heroSubtitle: "Hvor mennesker mødes, fødes fremtiden.",
    heroInvite: "En invitation til at tænke nyt.",
    cta: "Kom med",
    tapesTitle: "Indsæt en side",
    tapesSubtitle: "Vælg side A eller B og lyt.",
    tapesIntro:
      "Nogle gange er der brug for ord. Nogle gange er der brug for stilhed. Og nogle gange er der brug for musik, fordi den siger ting, som sproget er for lille til.",
    sideA: "RAUS AUS DEM falschen LEBEN",
    sideB: "OUT OF THE wrong LIFE",
    play: "Afspil",
    pause: "Pause",
    audioMissing: "Lyd ikke uploadet endnu",
    back: "Tilbage",
    backToHome: "Tilbage til start",
    scrollToTop: "Til toppen",
    downloadHint: "Dobbeltklik på",
    downloadHintSuffix: "for at downloade",
    impressum: "Kolofon",
    datenschutz: "Privatliv",
    kontakt: "Kontakt",
    impressumTitle: "Kolofon",
    datenschutzTitle: "Privatlivspolitik",
    kontaktTitle: "Kontakt",
    placeholder: "Indhold kommer snart.",
    rights: "Alle rettigheder forbeholdes.",
    languageLabel: "Sprog",
    menuEditorial: "Editorial",
    menuRaus: "RAUS AUS DEM falschen LEBEN",
    menuSong: "Sangen",
    menuSocialSeller: "Be a Social Seller",
    menuInspiration: "Inspiration",
    menuStimmen: "Stemmer",
    menuKontakt: "Kontakt",
    menuDownloads: "Downloads",
    presseTitle: "Presse",
    logoTitle: "RAUS AUS DEM falschen LEBEN",
    logoSubtitle: "En Socializer-bølge",
    downloadsTitle: "Downloads",
    downloadsIntro:
      "Her kan du downloade sangen og alle andre materialer. For dig. For din vej.",
    songListenNow: "Lyt nu",
    songDownload: "Download sang",
  },
};
